export default {
  en: {
    loginPage: {
      fillAll: "Please fill in all fields",
      welcomeBack: "Welcome back!",
      failed: "Login failed",
      monitoring: "Cameroon Election Monitoring"
    }
  },
  fr: {
    loginPage: {
      fillAll: "Veuillez remplir tous les champs",
      welcomeBack: "Bon retour parmi nous !",
      failed: "Échec de la connexion",
      monitoring: "Suivi des élections au Cameroun"
    }
  }
};
